<script setup lang="ts">
import SvgIcon from '@/components/base/SvgIcon.vue';
import { RouteEnum } from '@/constants/enums/RouteEnum';
import { env } from '@/env';
import { computed } from 'vue';
import { useRoute } from 'vue-router';

// 關於我們
const aboutUsData = {
  heading: '關於我們',
  data: [
    {
      title: '關於FUNDAY',
      link: 'https://funday.asia/B2B/?Pg=1',
      target: '_blank'
    },
    {
      title: '新聞中心',
      link: 'https://news.funday.asia/',
      target: '_blank'
    },
    {
      title: 'CEFR分級',
      link: 'https://funday.asia/B2B/?Pg=2',
      target: '_blank'
    },
    {
      title: '教學中心',
      link: 'https://funday.asia/TeachingCenter/index.html',
      target: '_blank'
    },
    // {
    //   title: '訂閱方案',
    //   // link: 'https://funday.asia/subscription/2023/',
    //   link: '/newSubscription',
    //   target: '_blank'
    // },
    {
      title: '學習專區',
      link: 'https://funday.asia/mylesson/intro3.asp',
      target: '_blank'
    }
  ]
};
// 更多頻道
const moreChannelData = {
  heading: '更多頻道',
  data: [
    {
      title: 'FunMusic',
      link: 'https://music.funday.asia',
      target: '_blank'
    },
    {
      title: 'FunTube',
      link: 'https://tube.funday.asia',
      target: '_blank'
    },
    {
      title: 'FunDictionary',
      link: 'https://dic.funday.asia',
      target: '_blank'
    },
    // {
    //     title: 'FunRadio',
    //     link: 'https://funradio.funday.asia/',
    //     target: '_blank'
    // },
    {
      title: 'FunTales',
      link: 'https://tales.funday.asia',
      target: '_blank'
    },
    {
      title: 'FUNDAY部落格',
      link: 'https://funday.asia/blogDesktop',
      target: '_blank'
    }
  ]
};
// 其他服務
const otherServiceData = {
  heading: '其他服務',
  data: [
    // {
    //   title: '國際英語學校',
    //   link: 'https://www.fundayis.org/',
    //   target: '_blank'
    // },
    {
      title: '企業培訓',
      link: 'https://funday.asia/B2B/?Pg=1',
      target: '_blank'
    },
    {
      title: '常見問題',
      // link: env.fqUrl,
      link: RouteEnum.FAQ,
      target: '_blank'
    },
    {
      title: '下載ZOOM',
      link: 'https://dimobo.com.tw/zntw_zoom_download.php?showType=ALL',
      target: '_blank'
    }
  ]
};
// 政策條款
const policyData = {
  heading: '政策條款',
  data: [
    {
      title: '隱私權政策',
      link: 'https://funday.asia/policy/policy.html',
      target: '_blank'
    },
    {
      title: '著作權聲明',
      link: 'https://funday.asia/copyright/copyright.html',
      target: '_blank'
    },
    {
      title: '履約保證',
      link: 'https://funday.asia/copyright/pg.html',
      target: '_blank'
    },
    {
      title: '網路安全提醒公告',
      link: 'https://funday.asia/security/',
      target: '_blank'
    }
  ]
};
//
const contactUsData = {
  heading: '聯絡我們',
  data: [
    {
      title: '+886-2-2523-9777',
      link: 'tel:+886-2-2523-9777'
    },
    {
      title: '0800-023-777(限市話)',
      link: 'tel:+886-0800-023-777'
    },
    {
      title: 'service@funday.asia',
      link: 'tel:+886-0800-023-777'
    },
    {
      title: '週一-週五 14:00-22:00',
      link: ';javascript;void(0)'
    }
  ]
};

const socialData = {
  heading: '追蹤我們',
  data: [
    {
      title: 'facebook',
      link: 'https://www.facebook.com/funday.asia',
      target: '_blank'
    },
    {
      title: 'instagram',
      link: 'https://www.instagram.com/funday.asia/',
      target: '_blank'
    },
    {
      title: 'youtube',
      link: 'https://www.youtube.com/channel/UCug7jmjK4hPey4R9n7zTwEQ/featured',
      target: '_blank'
    },
    {
      title: 'line2',
      link: 'https://line.me/R/ti/p/@wix6409v',
      target: '_blank'
    },
    {
      title: 'tiktok',
      link: 'https://www.tiktok.com/@funday.asia',
      target: '_blank'
    }
  ]
};

const route = useRoute();
const query = route.fullPath.split('?');
const currentYear = new Date().getFullYear();
const companyName = {
  ch_name: '智擎數位科技股份有限公司',
  en_name: 'Brainstorm Digital Communications Corp'
};
const uniformNum = '70469082';

const aboutUsDataMap = computed(() => {
  return aboutUsData.data.map((item) => {
    if (item.title === '訂閱方案') {
      return {
        ...item,
        link: `${item.link}?${query[1] ? query[1] : ''}`
      };
    }
    return item;
  });
});
const moreChannelDataMap = computed(() => {
  return moreChannelData.data.map((item) => ({
    ...item,
    link: `${item.link}?${query[1] ? query[1] : ''}`
  }));
});
</script>

<template>
  <footer class="login-footer">
    <div class="login-footer-wrapper pageContainer">
      <div class="footer-top">
        <div class="footer-top-wrapper">
          <div class="col aboutUs">
            <h3 class="footer-heading">
              {{ aboutUsData.heading }}
            </h3>
            <ul class="footer-list">
              <li v-for="item in aboutUsDataMap" class="footer-item">
                <a class="footer-item-link" :href="item.link" :target="item.target">
                  {{ item.title }}
                </a>
              </li>
            </ul>
          </div>

          <div class="col moreChannel">
            <h3 class="footer-heading">
              {{ moreChannelData.heading }}
            </h3>
            <ul class="footer-list">
              <li v-for="item in moreChannelDataMap" class="footer-item">
                <a class="footer-item-link" :href="item.link" :target="item.target">
                  {{ item.title }}
                </a>
              </li>
            </ul>
          </div>

          <div class="col otherService">
            <h3 class="footer-heading">
              {{ otherServiceData.heading }}
            </h3>
            <ul class="footer-list">
              <li v-for="item in otherServiceData.data" class="footer-item">
                <a class="footer-item-link" :href="item.link" :target="item.target">{{
                  item.title
                }}</a>
              </li>
            </ul>
          </div>

          <div class="col policy">
            <h3 class="footer-heading">
              {{ policyData.heading }}
            </h3>
            <ul class="footer-list">
              <li v-for="item in policyData.data" class="footer-item">
                <a class="footer-item-link" :href="item.link" :target="item.target">{{
                  item.title
                }}</a>
              </li>
            </ul>
          </div>

          <div class="col contactUs">
            <h3 class="footer-heading">
              {{ contactUsData.heading }}
            </h3>
            <ul class="footer-list">
              <li v-for="item in contactUsData.data" class="footer-item">
                <a class="footer-item-link" :href="item.link">{{ item.title }}</a>
              </li>
            </ul>
          </div>

          <div class="col followUs">
            <h3 class="footer-heading">
              {{ socialData.heading }}
            </h3>
            <ul class="footer-list row">
              <li v-for="item in socialData.data" class="footer-item">
                <a class="footer-item-icon" :href="item.link">
                  <SvgIcon :name="item.title" />
                </a>
              </li>
            </ul>
            <a href="https://apps.apple.com/app/id6670745600" class="download-link mb-[20px]">
              <SvgIcon name="ios" />
            </a>
            <a href="https://play.google.com/store/apps/details?id=com.funday.newfunday" class="download-link">
              <SvgIcon name="android" />
            </a>
          </div>
        </div>
      </div>

      <div class="footer-bottom">
        <div class="footer-bottom-wrapper">
          <div class="company-info">
            <div>{{ companyName.ch_name }} 轉載必究｜統一編號：{{ uniformNum }}</div>
            <div>｜Taipei City, Taiwan</div>
            <RouterLink :to="{ name: RouteEnum.Sitemap }">｜網站地圖</RouterLink>
          </div>
          <div class="copyright">
            © {{ currentYear }} {{ companyName.en_name }}. All rights reserved.Privacy policyData
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>
<style scoped lang="scss">
.login-footer {
  background-color: $bg-dark-100;

  &-wrapper {
    padding-block: 50px;
    padding-inline: 10%;
    display: flex;
    flex-direction: column;
    gap: 92px;

    @include media-breakpoint-down(lg) {
      padding-inline: 10%;
    }

    @include media-breakpoint-down(md) {
      padding: 32px;
    }
    @include media-breakpoint-down(sm) {
      padding-inline: 8px;
    }
  }

  .footer {
    &-top {
      &-wrapper {
        display: grid;
        grid-template-areas: 'aboutUs moreChannel otherService policy contactUs  followUs';
        gap: 3%;

        @include media-breakpoint-down(2xl) {
          grid-template-areas:
            'aboutUs moreChannel otherService policy'
            'contactUs contactUs  followUs followUs';
          grid-template-rows: auto;
        }
        @include media-breakpoint-down(md) {
          grid-template-areas:
            'aboutUs moreChannel' 'otherService policy'
            'contactUs  contactUs' 'followUs followUs ';
          row-gap: 80px;
        }
      }

      .download-link {
        display: flex;
        align-items: center;

        svg {
          width: 180px;
          height: 54px;
        }
      }
    }

    &-heading {
      font-size: 16px;
      font-weight: 600;
      line-height: 150%;
      color: $color-white-base;
    }

    &-list {
      display: flex;
      flex-direction: column;
      gap: 16px;
      padding-top: 24px;

      &.row {
        flex-direction: row;
        padding-bottom: 20px;
      }
    }

    &-item {
      font-size: 16px;
      line-height: 150%;
      display: block;

      &-link {
        color: $txt-color-white-40;
        @include default-transition;

        &:hover {
          color: $txt-color-white-100;
        }
      }

      &-icon {
        @include flex-center;
        @include wh(30);
        @include default-transition;
        color: $txt-color-white-90;

        &:hover {
          color: $txt-color-white-100;
        }
      }
    }

    &-bottom {
      text-align: center;
      color: $txt-color-white-40;
      font-size: 14px;

      &-wrapper {
        display: flex;
        flex-direction: column;
        gap: 8px;
      }
    }
  }

  .aboutUS {
    grid-area: aboutUs;
  }

  .moreChannel {
    grid-area: moreChannel;
  }

  .otherService {
    grid-area: otherService;
  }

  .policy {
    grid-area: policy;
  }

  .contactUs {
    grid-area: contactUs;
  }

  .followUs {
    grid-area: followUs;
  }
}

.company-info > * {
  display: inline;
  color: rgba(255, 255, 255, 0.4);
}
</style>
